module.exports = __webpack_public_path__ + "static/media/catalogo.73a47d42.png";